import { render, staticRenderFns } from "./ErrAuth.vue?vue&type=template&id=096efaf7"
import script from "./ErrAuth.vue?vue&type=script&lang=js"
export * from "./ErrAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports